import { CareText } from "../../ui/text/CareText/CareText";
import { CareTitle } from "../../ui/text/CareTitle/CareTitle";
import { CareContentWrap } from "../../ui/wrappers/CareContentWrap/CareContentWrap";

export const CareKimchi = () => {
  return (
    <CareContentWrap>
      <title>Как ухаживать за вещами MIYUKON</title>
      <meta
        name="description"
        content="Инструкции по уходу без канцелярщины. Чтобы ткань дышала, принт не тускнел, а вещь жила дольше."
      />
      <meta property="og:title" content="Как ухаживать за вещами MIYUKON" />
      <meta
        property="og:description"
        content="Стирайте, сушите и храните с заботой — и вещь будет жить дольше."
      />
      <meta property="og:url" content="https://miyukon.ru/care/kimchi" />
      {/*<meta property="og:image" content="https://miyukon.ru/path-to-your-og-image.jpg" />*/}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MIYUKON" />
      <CareTitle>Kimchi — пульс корейской традиции</CareTitle>
      <CareText>
        Принт в коллекции Kimchi — не просто графика. Он вдохновлён одним из
        главных символов корейской культуры: капустой кимчи. Яркий, насыщенный,
        живой — он требует такого же бережного отношения. Следуйте
        рекомендациям, чтобы сохранить глубину цвета и чёткость линий.
      </CareText>
      <CareTitle>Состав</CareTitle>
      <CareText>
        <span style={{ fontWeight: 600 }}>Футболки:</span> 100% хлопок
      </CareText>
      <CareTitle>Стирка</CareTitle>
      <CareText>
        <span style={{ fontWeight: 600 }}>Температура:</span> до 30 °C,
        деликатный режим
        <br />
        <span style={{ fontWeight: 600 }}>Режим:</span> без агрессивного отжима
        и сильного трения
        <br />
        <span style={{ fontWeight: 600 }}>Средства:</span> только мягкие моющие
        средства без отбеливателей
        <br />
        <br />
        <span style={{ fontWeight: 600 }}>Совет MIYUKON:</span> Стирайте
        изделие, вывернув наизнанку — так принт дольше сохранит насыщенность и
        фактуру.
      </CareText>
      <CareTitle>Сушка</CareTitle>
      <CareText>
        <span style={{ fontWeight: 600 }}>Способ:</span> горизонтально на чистой
        поверхности или аккуратно развесив, избегая прямых солнечных лучей
        <br />
        <span style={{ fontWeight: 600 }}>Избегайте:</span> барабанной сушки и
        интенсивных режимов
        <br />
        <br />
        <span style={{ fontWeight: 600 }}>Совет MIYUKON:</span> После стирки
        аккуратно расправьте рисунок руками — это сохранит чёткость контуров.
      </CareText>
      <CareTitle>Глажка</CareTitle>
      <CareText>
        <span style={{ fontWeight: 600 }}>Температура:</span> до 150 °C
        <br />
        <span style={{ fontWeight: 600 }}>Способ:</span> через тонкую ткань или
        с изнаночной стороны
        <br />
        <br />
        <span style={{ fontWeight: 600 }}>Совет MIYUKON:</span> Избегайте
        давления — гладьте плавно, чтобы сохранить структуру принта.
      </CareText>
      <CareTitle>Хранение</CareTitle>
      <CareText>
        На вешалке или сложенной вровень, без плотных стопок
        <br />
        <br />
        <span style={{ fontWeight: 600 }}>Совет MIYUKON:</span> Ткань «дышит»,
        когда вокруг есть воздух — оставляйте вещи с небольшим пространством.
      </CareText>
      <CareTitle>Частые вопросы</CareTitle>
      <CareText>
        <span style={{ fontWeight: 600 }}>Можно ли стирать вручную?</span>
        <br />
        Да. Тёплая вода (до 30 °C) и мягкое мыло — деликатный и надёжный способ.
        <br />
        <br />
        <span style={{ fontWeight: 600 }}>Подходит ли для химчистки?</span>
        <br />
        Да, если используются щадящие режимы без агрессивных растворителей.
      </CareText>
    </CareContentWrap>
  );
};
